import { sql, eq } from "drizzle-orm";
import { integer, real, sqliteTable, text } from "drizzle-orm/sqlite-core";
import { getDb } from "../db";

export type SelectLPToken = typeof LPToken.$inferSelect;

export const LPToken = sqliteTable('LPToken', {
	address: text('lpTokenAddress').primaryKey(),
	symbol: text('symbol').notNull(),
	name: text('name'),
	iconUrl: text('iconUrl'),
	totalSupply: real('totalSupply')
});

export function storeLPToken(token: SelectLPToken) {
	return getDb()
		.insert(LPToken)
		.values(token)
		.onConflictDoUpdate({
			target: LPToken.address, set: { ...token } })
		.returning({ address: LPToken.address })
}

export async function getLPTokens() {
	return getDb()
		.select()
		.from(LPToken)
		.all();
}

export async function getLPToken(address: string) {
	return getDb()
		.select()
		.from(LPToken)
		.where(eq(LPToken.address, address))
		.all();
}